import {FC, useCallback} from 'react';
import {TopicModule} from '@/services/pages/channel/channel.client';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';


interface BrandEntryProps {
    info: TopicModule;
    channelBusinessLine?: string;
    page?: string;
}

const BrandEntry: FC<BrandEntryProps> = ({info, channelBusinessLine, page}) => {

    const {navigateToUrl} = useJumpUrl();
    const brandEntryInfo = info.itemList?.[info.itemList?.length - 1]?.fieldValue || {};

    const handleClick = useCallback(
        () => {
            if (brandEntryInfo.link) {
                const urlParams = {
                    linkUrl: brandEntryInfo.link,
                };
                const logParams = {
                    page: page,
                    value: 'jump_levitated_sphere',
                    channelId: info.channelId,
                    pageType: channelBusinessLine,
                    moduleId: info.moduleId,
                    moduleName: info.moduleName,
                };
                navigateToUrl(urlParams, logParams);
            }
        },
        [brandEntryInfo.link, channelBusinessLine, info.channelId, info.moduleId, info.moduleName, navigateToUrl, page]
    );

    return (
        <div
            data-show={JSON.stringify({
                page: page,
                value: 'jump_levitated_sphere',
                pageSourceId: info.channelId,
                pageType: channelBusinessLine,
                valueId: info.moduleId,
                valueTitle: info.moduleName,
                valueType: VALUE_TYPE.MODULE,
            })}
            className={styles.brandEntry}
            onClick={handleClick}
        >
            <img src={brandEntryInfo.title} className={styles.img} />
        </div>
    );
};

export default BrandEntry;
